// extracted by mini-css-extract-plugin
export var carouselContainer = "M_wQ d_w d_H d_bf d_Z";
export var carouselContainerCards = "M_wR M_wQ d_w d_H d_bf d_Z";
export var carouselContainerSides = "M_wS d_w d_H d_Z";
export var prevCarouselItem = "M_wT d_w d_H d_0 d_k";
export var prevCarouselItemL = "M_wV M_wT d_w d_H d_0 d_k";
export var moveInFromLeft = "M_wW";
export var prevCarouselItemR = "M_wX M_wT d_w d_H d_0 d_k";
export var moveInFromRight = "M_wY";
export var selectedCarouselItem = "M_wZ d_w d_H d_Z d_bf";
export var selectedCarouselItemL = "M_w0 M_wZ d_w d_H d_Z d_bf";
export var selectedCarouselItemR = "M_w1 M_wZ d_w d_H d_Z d_bf";
export var nextCarouselItem = "M_w2 d_w d_H d_0 d_k";
export var nextCarouselItemL = "M_w3 M_w2 d_w d_H d_0 d_k";
export var nextCarouselItemR = "M_w4 M_w2 d_w d_H d_0 d_k";
export var arrowContainer = "M_w5 d_H d_0 d_dB d_bl d_4 d_b1";
export var prevArrowContainer = "M_w6 M_w5 d_H d_0 d_dB d_bl d_4 d_b1";
export var prevArrowContainerHidden = "M_w7 M_w6 M_w5 d_H d_0 d_dB d_bl d_4 d_b1 d_k";
export var nextArrowContainer = "M_w8 M_w5 d_H d_0 d_dB d_bl d_4 d_b1";
export var carouselContainerProducts = "M_w9";
export var nextArrowContainerHidden = "M_xb M_w8 M_w5 d_H d_0 d_dB d_bl d_4 d_b1 d_k";
export var arrow = "M_kG d_0";
export var prevArrow = "M_xc M_kG d_0";
export var nextArrow = "M_xd M_kG d_0";
export var carouselIndicatorContainer = "M_xf d_w d_dw d_bl d_bz d_bD d_bP d_bJ d_0";
export var btnsContainer = "M_xg d_w d_bz d_bF";
export var carouselText = "M_xh d_dq d_bz d_bD d_bP d_b1 d_dB d_cD";
export var carouselTextInactive = "M_xj M_xh d_dq d_bz d_bD d_bP d_b1 d_dB d_cD";
export var indicator = "M_xk d_b7";
export var carouselIndicator = "M_xl M_xk d_b7";
export var carouselIndicatorSelected = "M_xm M_xk d_b7";
export var arrowsContainerTopRight = "M_xn d_0 d_bl d_bC";
export var arrowsContainerBottomLeft = "M_xp d_0 d_bl d_bC";
export var arrowsContainerSides = "M_xq d_0 d_bl d_bC";
export var smallArrowsBase = "M_xr d_bT d_bz d_bD d_bP d_b1 d_dB d_cD";
export var smallArrowContainer = "M_xs M_xr d_bT d_bz d_bD d_bP d_b1 d_dB d_cD";
export var smallArrowContainerPrev = "M_xt M_xs M_xr d_bT d_bz d_bD d_bP d_b1 d_dB d_cD";
export var smallArrowContainerSmall = "M_xv M_xr d_bT d_bz d_bD d_bP d_b1 d_dB d_cD";
export var smallArrowContainerPrevSmall = "M_xw M_xv M_xr d_bT d_bz d_bD d_bP d_b1 d_dB d_cD";
export var icon = "M_n9";
export var iconSmall = "M_xx";
export var multipleWrapper = "M_xy d_bC d_bF d_bf";
export var multipleImage = "M_xz d_bC";
export var sidesPrevContainer = "M_xB M_xs M_xr d_bT d_bz d_bD d_bP d_b1 d_dB d_cD d_fn d_0 d_bl d_cD";
export var sidesNextContainer = "M_xC M_xs M_xr d_bT d_bz d_bD d_bP d_b1 d_dB d_cD d_fn d_0 d_bl d_cD";